export enum RoutingTypeEnum {
  P2P = "P2P",
  P2D = "P2D",
  D2P = "D2P",
  D2D = "D2D",
}

export type RoutingType = `${RoutingTypeEnum}`;
